import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import { BUTTON_TYPES } from "@/components_v2/Button/constants";
import RequirementChip from "@/domains/certifications/components/RequirementChip";
import { certificationPaths } from "@/domains/certifications/routes";
import { buildRequirementChips } from "@/domains/certifications/chips";
import { CurrentWeekCardProps } from "@/features/certifications/overview/components/types";
import { getModuleVideoMeta } from "@/domains/certifications/utils";

import "./styles.css";

const CurrentWeekCard = ({ slug, week, contentKey }: CurrentWeekCardProps) => {
  const { t } = useTranslation();
  const moduleKey = `${contentKey}.modules.${week.module.slug}`;
  const description = t(`${moduleKey}.description`, {
    defaultValue: t(`${moduleKey}.summary`, { defaultValue: "" }),
  });

  return (
    <div className="current-week-card flex flex-col gap-300">
      <div className="flex flex-wrap items-start justify-between gap-300">
        <div className="flex flex-col gap-200">
          <div className="flex items-center gap-200">
            <span className="current-week-label body-xs-regular">
              {t("certification.overview.weekLabel", {
                position: week.position,
              })}
            </span>

            <span className="certification-muted body-xs-regular">
              {week.isStarted
                ? t("certification.overview.inProgress")
                : t("certification.overview.readyToStart")}
            </span>
          </div>

          <h3 className="current-week-title header-l-medium">
            {week.module.title}
          </h3>
        </div>

        <BaseButton
          type={BUTTON_TYPES.LINK}
          to={certificationPaths.module(slug, week.module.id)}
        >
          {week.isStarted
            ? t("certification.overview.continue")
            : t("certification.overview.startWeek", {
                position: week.position,
              })}
        </BaseButton>
      </div>

      {description && (
        <p className="current-week-description certification-muted body-s-regular">
          {description}
        </p>
      )}

      {week.isStarted ? (
        <div className="flex flex-wrap gap-200">
          {buildRequirementChips(t, week).map((chip) => (
            <RequirementChip key={chip.label} {...chip} />
          ))}
        </div>
      ) : (
        <span className="week-row-meta body-xs-regular">
          {getModuleVideoMeta(t, week.module)}
        </span>
      )}
    </div>
  );
};

export default CurrentWeekCard;
